import { createContext, useContext, useState, useEffect, ReactNode } from 'react'

type BatteryContextType = {
  battery: number
  setBattery: (value: number | ((prev: number) => number)) => void
  isDead: boolean
  setIsDead: (value: boolean) => void
}

const BatteryContext = createContext<BatteryContextType | undefined>(undefined)

export function BatteryProvider({ children }: { children: ReactNode }) {
  const [battery, setBattery] = useState(100)
  const [isDead, setIsDead] = useState(false)

  useEffect(() => {
    const b = setInterval(() => {
      setBattery(v => {
        const next = v > 0 ? +(v - 0.05).toFixed(2) : 0
        return next
      })
    }, 1000)
    
    return () => clearInterval(b)
  }, [])

  useEffect(() => {
    if (battery <= 0 && !isDead) {
      setIsDead(true)
    }
  }, [battery, isDead])

  return (
    <BatteryContext.Provider value={{ battery, setBattery, isDead, setIsDead }}>
      {children}
    </BatteryContext.Provider>
  )
}

export function useBattery() {
  const context = useContext(BatteryContext)
  if (!context) {
    throw new Error('useBattery must be used within BatteryProvider')
  }
  return context
}
